var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98516 8.63354C7.3257 5.56868 9.91628 3.25 13 3.25V3.25C16.0837 3.25 18.6743 5.56868 19.0148 8.63354L19.2876 11.0886C19.3071 11.2638 19.3168 11.3514 19.3283 11.4378C19.4648 12.4617 19.7982 13.4495 20.3102 14.3467C20.3534 14.4224 20.3988 14.498 20.4895 14.6491L21.1157 15.6928C21.7532 16.7553 22.072 17.2866 21.9384 17.7146C21.896 17.8504 21.8251 17.9757 21.7304 18.0819C21.4322 18.4167 20.8126 18.4167 19.5734 18.4167H6.42658C5.18742 18.4167 4.56784 18.4167 4.26958 18.0819C4.17491 17.9757 4.10401 17.8504 4.06161 17.7146C3.92802 17.2866 4.2468 16.7553 4.88434 15.6928L5.51054 14.6491C5.60122 14.498 5.64656 14.4224 5.68979 14.3467C6.20181 13.4495 6.53524 12.4617 6.67166 11.4378C6.68318 11.3514 6.69291 11.2638 6.71238 11.0886L6.98516 8.63354Z",
    stroke: "#212529",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66536 18.4167C8.66536 18.9857 8.77745 19.5492 8.99522 20.075C9.21299 20.6007 9.53218 21.0784 9.93457 21.4808C10.337 21.8832 10.8147 22.2024 11.3404 22.4201C11.8661 22.6379 12.4296 22.75 12.9987 22.75C13.5678 22.75 14.1312 22.6379 14.657 22.4201C15.1827 22.2024 15.6604 21.8832 16.0628 21.4808C16.4652 21.0784 16.7844 20.6007 17.0022 20.075C17.2199 19.5492 17.332 18.9857 17.332 18.4167",
    stroke: "#212529",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.883166b0f63888bff5e34105332148ff.svg";
export { ForwardRef as ReactComponent };